// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"c0ea40bf","202":"bf9537ea","231":"ca4bc8a8","252":"070482f0","314":"f67e1244","591":"e952bb1f","596":"34e82e10","606":"d64e3019","836":"481f5362"}[chunkId] + ".chunk.js";
};